export default __webpack_public_path__ + "static/media/textpos.42a02469.png";